import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import axios from 'axios';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { GATEWAY_TIMEOUT_STATUS_CODE } from '../recoil/types/types';

export function useIssueInsurance(): {
    issueInsurance: () => Promise<string>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const issueInsurance = async (): Promise<string> => {
        let resultPolicyNumber: string = '';
        try {
            resultPolicyNumber = await OnlineSales.issue(jobNumber, sessionId);
        } catch (err) {
            if (axios.isAxiosError(err) && err.response?.status !== GATEWAY_TIMEOUT_STATUS_CODE) {
                throw err;
            }
        }
        return resultPolicyNumber ?? '';
    };

    return { issueInsurance };
}
